import $ from "../libs/jquery-3.3.1.min.js"
import {BaseGame} from "/js/app/base/BaseGame";
import {gsap} from "../libs/gsap/all.js"
import * as Tone from "tone";
import {Howl} from "howler";

// Constructor
export class VideotronSequenceur extends BaseGame {

  constructor() {

    // Super constructor
    super("data/gustav_videotron_sequenceur.json"); // unneeded but let's keep it if we need to later on

    this.timeline = null;
    this.scheduleRepeatID = null;
    this.currentBeatsCount = 32;
    this.currentNotesSpeed = "8n";

    this.tracksMap = {};
    this.currentTrackKey = null;

    this.currentMode = "piano"; // piano mode doesn't have a back track and no looping

    this.soundsMap = {};

    this.currentStep = 0;
    this.stepsMap = {};
    this.soundsHistory = [];

    // Wait for all
    Promise.all([
      this.loadSettings(),
      this.loadData()
    ]).then(() => {
      // Preload audio files
      return this.preloadAudio();
    }).then(() => {
      // Ini nunjucks
      return this.initNunjucks();
    }).then(() => {
      // Replace strings {{ }}
      return this.renderNunjucks();
    }).then(() => {
      // Real game init
      return this.initGame();
    }).then(() => {
      // Start
      return this.startGame();
    }).catch((error) => {
      console.error("error", error)
      $("#main").append("<div id='error'>Error: " + error.message + "</div>")
    });

    window.Tone = Tone;
  }

  // To be overridden in child games
  initGame() {

    return new Promise((resolve, reject) => {
      $(".sequenceur-wrapper").toggleClass("debug", this.settings.debug);

      // build tracks map so it's easier to access it by key
      for (let i = 0; i < this.data.tracks.length; i++) {
        this.tracksMap[this.data.tracks[i].key] = this.data.tracks[i];

        this.tracksMap[this.data.tracks[i].key].audio = new Howl({
          src: [this.data.tracks[i].src],
          volume: this.data.tracks[i].volume,
          loop: true,
          html5: true
        });
      }

      // build sounds map
      for (let i = 0; i < this.data.sounds.length; i++) {
        if (typeof this.soundsMap[this.data.sounds[i].key] !== "undefined") {
          console.log("Key Already exists, skipping.", this.data.sounds[i]);
          continue;
        }
        this.soundsMap[this.data.sounds[i].key] = this.data.sounds[i].src;
        this.stepsMap[this.data.sounds[i].key] = Array(this.settings.timeline_total_beats).fill(0);

        // Generate the debug sequencer viewer grid
        if (this.settings.debug) {
          let $gridRow = $('<div class="grid-row" data-key="' + this.data.sounds[i].key + '"></div>');
          for (let j = 0; j < this.settings.timeline_total_beats; j++) {
            $gridRow.append('<span class="grid-cell"></span>');
          }
          $gridRow.append('<span class="row-indicator">' + this.data.sounds[i].key + '</span>');
          $(".grid-wrapper").append($gridRow);
        }
      }

      this.toneKeys = new Tone.Players({
        urls: this.soundsMap,
        // release: 1,
        fadeOut: "16n",
        // baseUrl: "audio/",
      }).toDestination();

      this.currentBeatsCount = this.settings.timeline_total_beats; // base value
      this.currentNotesSpeed = this.settings.notes_speed; // base value

      this.scheduleRepeatID = Tone.getTransport().scheduleRepeat(this.loop.bind(this), this.currentNotesSpeed);
      Tone.getTransport().bpm.value = this.settings.timeline_bpm; // this will be overwritten by the back track
      Tone.getTransport().start();

      // Trigger the first sound quietly to prevent a bug where the first time a sound is
      // played it seems truncated for a reason. Works fine after this
      // this.audio.play(this.soundsMap["q"], 0.001, true);

      // init timeline
      this.resetTimeline();

      this.initScreenSaver();


      // Let's also use the keyboard to trigger a button state change so we can debug easier
      $(document).on('keydown', (e) => {
        // resume the audio context if not running because browser blocks it
        if (Tone.getContext().state !== 'running') {
          Tone.getContext().resume();
        }

        switch (e.key) {
          case "1":
          case "2":
          case "3":
          case "4":
          case "5":
          case "6":
          case "7":
          case "8":
          case "9":
          case "0":
            this.switchMode("record");
            this.changeTrack(e.key);
            break;

          case "Delete":
          case "Backspace":
            this.removeLastSound();
            break;

          case "Escape":
            this.switchMode("piano");
            // this.resetTimeline();
            break;

          default:
            this.addSound(e.key);
            break;
        }
      })

      resolve();
    });
    // super.initGame(); // We don't need the BaseGame in this case so let's skip it and handle things just here
  };

  initScreenSaver() {
    // Timeout (screensaver) related
    // Let's override the Basegame function because we are using the keyboard only and not the mouse

    this.resetTimer();

    $(document).on("keydown", (e) => {
      this.resetTimer();
    });

    requestInterval(() => this.checkTimer(), 1000);
  }

  shouldReset() {
    if (millis() - this.lastReset < 3000) {
      return false;
    }

    this.lastClick = millis();
    this.lastReset = millis();

    // Reset only if we are not already on the piano mode
    if (this.currentMode === "piano") {
      return false;
    }

    return true;
  }


  startGame() {
    // start without audio and no looping
    this.currentMode = "piano";
  }

  switchMode(mode) {

    if (this.currentMode == mode) {
      return; // already in the same mode, so skip
    }

    this.currentMode = mode;

    if (this.currentMode == "piano") {
      this.resetTimeline();
      this.stopAllTracks();
    }

  }

  loop(time) {
    this.currentStep++;
    this.currentStep = this.currentStep % this.currentBeatsCount;

    for (const [key, steps] of Object.entries(this.stepsMap)) {
      if (steps[this.currentStep] == 1) {
        this.toneKeys.player(key).start(time);
        // this.toneKeys.player(key).start();
      }
    }

    if (this.settings.debug) {
      $(".step-indicator").css({
        left: `${(this.currentStep) / this.currentBeatsCount * 100}%`,
        marginLeft: $(".grid-cell").first().width() / 2
      });
    }

    this.animateProgress();
  }

  animateProgress() {

    if (this.currentMode == "piano") {
      $(".progress-bar-line").css({
        width: 0
      });

      $(".progress-markers .marker").removeClass("active");
    } else {

      if (this.currentTrackKey == "0") {
        $(".progress-bar-line").css({
          width: 0
        });
      } else if (typeof this.tracksMap[this.currentTrackKey] !== "undefined") {
        $(".progress-bar-line").css({
          width: `${(this.tracksMap[this.currentTrackKey].audio.seek() / this.tracksMap[this.currentTrackKey].audio.duration()) * 100}%`
        });
      }

      let stepToHighlight = Math.max(0, Math.ceil(this.currentStep / this.currentBeatsCount * 8) - 1);
      $(".progress-markers .marker").removeClass("active");
      $(".progress-markers .marker").eq(stepToHighlight).addClass("active");
    }

  }

  changeTrack(key) {

    if (typeof this.tracksMap[key] === "undefined") {
      return;
    }

    // console.log("changing track to ", key);

    // TODO: not working as it should so let's keep it at 1 setting and only change the BPM
    // this.currentBeatsCount = this.tracksMap[key].timeline_total_beats;
    // this.currentNotesSpeed = this.tracksMap[key].notes_speed;

    this.resetTimeline();
    this.stopAllTracks();

    this.tracksMap[key].audio.play();

    this.currentTrackKey = key;


    // TODO: not working as it should so let's keep it at 1 Schedule setting and only change the BPM
    // Tone.getTransport().clear(this.scheduleRepeatID);
    // this.scheduleRepeatID = Tone.getTransport().scheduleRepeat(this.loop.bind(this), this.currentNotesSpeed);
    Tone.getTransport().bpm.value = this.tracksMap[key].bpm;
    // console.log("New schedule", this.scheduleRepeatID);

    // setTimeout(()=>{
    //   Tone.getTransport().start();
    //   console.log("Start schedule", this.scheduleRepeatID);
    // }, 100);

    // console.log("Changing total beats to ", this.currentBeatsCount)
    // console.log("Changing notes speed to ", this.currentNotesSpeed)
    // console.log("Changing bpm to ", Tone.getTransport().bpm.value)
  }

  stopAllTracks() {
    for (const [key, track] of Object.entries(this.tracksMap)) {
      track.audio.stop();
    }
  }

  addSound(key) {

    if (typeof this.stepsMap[key] === "undefined") {
      return;
    }

    // Trigger the sounds directly with Tone instead of going with Howl because this way the sounds can't overlap and it's more like a real sequencer
    // and you still get immediate feedback
    this.toneKeys.player(key).start();

    if (this.currentMode == "record") {

      // Store the variable immediately in case the currentStep is already further than when we pressed
      let stepToBeAdded = this.currentStep;

      // Add the sound to the steps so it will play on the next loop
      this.stepsMap[key][stepToBeAdded] = 1;

      // Add the sound to the history so we can clear it later
      this.soundsHistory.push({key: key, step: stepToBeAdded});

      // Set debug state if needed
      if (this.settings.debug) {
        $(".grid-row[data-key='" + key + "']").find(".grid-cell").eq(stepToBeAdded).addClass("active");
      }

      // // First let's check if that sound is already played at the current step
      // // if so, skip it
      // // otherwise, play it now for immediate feedback and on ended, add it to the sequence so it will be played next loop
      // if (this.stepsMap[key][stepToBeAdded] != 1) {
      //   if (this.settings.debug) {
      //     $(".grid-row[data-key='" + key + "']").find(".grid-cell").eq(stepToBeAdded).addClass("active");
      //   }
      //   this.soundsHistory.push({key: key, step: stepToBeAdded});
      // }

      // this.audio.play(this.soundsMap[key], this.settings.volume, true, () => {
      //   if (this.stepsMap[key][stepToBeAdded] != 1) {
      //     this.stepsMap[key][stepToBeAdded] = 1;
      //   }
      // }, null, false, "sound");
    }

  }

  removeLastSound() {
    if (this.soundsHistory.length > 0) {

      let lastSound = this.soundsHistory.pop();

      // this.audio.clearLastByFilename(this.soundsMap[lastSound.key]); // Not needed anymore as we are trigger sounds with Tone directly

      this.toneKeys.player(lastSound.key).stop();

      // Clear from the steps
      this.stepsMap[lastSound.key][lastSound.step] = 0

      // Change debug state if needed
      if (this.settings.debug) {
        $(".grid-row[data-key='" + lastSound.key + "']").find(".grid-cell").eq(lastSound.step).removeClass("active");
      }
    }
  }

  resetTimeline() {

    // this.audio.clearAllByType("sound", true); // do not kill current track, clear only sounds; Edit: Not needed anymore as we are trigger sounds with Tone directly

    for (const [key, steps] of Object.entries(this.stepsMap)) {
      this.stepsMap[key] = Array(this.currentBeatsCount).fill(0);
      this.toneKeys.player(key).stop();
    }

    this.soundsHistory = [];

    this.currentStep = 0;

    if (this.settings.debug) {
      $(".grid-row .grid-cell").removeClass("active");
    }

  }

  reset(screenId) {

    // Let's go back to piano mode
    this.switchMode("piano");

    // There is no real need to reset the app here as it's a single screen app in this case

    // if (this.timeline) {
    //   this.timeline.kill();
    //   this.timeline = null;
    // }
    //
    // let resetCallback = () => {
    //   // TODO Add things to append after reset here, if required
    //
    //
    // }
    //
    // // TODO Reset other things here
    // this.animateScreen1();

    // // Super
    // if (super.reset(screenId, resetCallback) == false) {
    //   return false;
    // }

  }

  randomInArray(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }
}
